// extracted by mini-css-extract-plugin
module.exports = {"root":"EditUserAgeForm_root__2HMIk","field":"EditUserAgeForm_field__PvctI"};